module.exports = __webpack_public_path__ + "static/media/header_slider_1.2ed9037a.jpg";